import { UserSettingsComponent } from './header/user-settings/user-settings.component';
import { AfterViewChecked, ChangeDetectorRef, Component, HostListener, Inject, OnInit, Renderer2 } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { LocalStorageService } from '../util/services/local-storage/local-storage.service';
import { Globals } from '../Globals';
import { User } from '../util/interfaces/user/user';
import { EventEmitter } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../auth/services/auth.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-base-layout',
  templateUrl: './base-layout.component.html',
  styleUrls: ['./base-layout.component.sass']
})
export class BaseLayoutComponent implements OnInit, AfterViewChecked {
  isLoading$: Observable<boolean>;
  mode: `over`;
  usuario: User;
  hasBackdrop: `true`;

  isSmall: boolean;
  isMenuOpen: boolean = false;
  isDark = true;
  innerWidth: number;
  imageToShowDialog: string;

  constructor(
    private store: Store<{ count: boolean }>,
    private cdRef: ChangeDetectorRef,
    public localStorageService: LocalStorageService,
    private globals: Globals,
    @Inject(DOCUMENT) private document: Document,
    private render: Renderer2,
    private dialog: MatDialog,
    private authService: AuthService
  ) {
  }

  ngOnInit(): void {
    this.getUsuario();
  }

  getUsuario(): void {
    this.usuario = this.localStorageService.getUserFromStorage();
    this.imageToShowDialog = environment.FILE_ENDPOINT + this.usuario.userData.foto_perfil;
  }

  ngAfterViewChecked(): void {
    this.isLoading$ = this.store.select('count');
    this.cdRef.detectChanges();
  }

  getSystemVersion(): string {
    return this.globals.getSystemVersion();
  }

  // onDarkMode() {
  //   this.modeSwitched.emit(true);
  // }

  switchMode(isDark: boolean): void {
    // this.isDark = !this.isDark;
    // if (isDark) {
    //   this.document.documentElement.classList.remove('mat-typography');
    //   this.document.documentElement.classList.add('dark');
    // } else {
    //   this.document.documentElement.classList.remove('dark')
    //   this.document.documentElement.classList.add('mat-typography');
    // }
    const hostClass = (isDark) ? 'dark' : 'mat-typography';
    this.render.setAttribute(this.document.documentElement, 'class', hostClass);
    this.isDark = !this.isDark;
  }

  openSettings(): void {
    const dialog = this.dialog.open(UserSettingsComponent, {
      autoFocus: false,
      width: '55vw',
      data: this.isLoading$
    })
  }

  logout(): void {
    this.authService.logout();
  }

  // Resize para el SideBar!
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = event.target.innerWidth;
    this.innerWidth < 1200 ? this.isMenuOpen = false : this.isMenuOpen = true;
  }

}